import { BigBashEvent, Game, ScreenContent, ScreenContentEnum } from "@/types/types";
import { html } from "lit";
import { TemplateResult } from "lit-element/lit-element";
import ChartPropsManager from "./ChartPropsManager";
// Ensure the Jeopardy grid display element is available
import "./JeopardyGridDisplay";
import "./MillionaireBroadcast";

class DisplayContentSwitch {
	roomId: string;
	chartCreator: ChartPropsManager;

	constructor(roomId: string) {
		this.roomId = roomId;
		this.chartCreator = new ChartPropsManager();
	}

	public getDisplayContent(
		screenContent: ScreenContent,
		currentEvent?: BigBashEvent,
		currentGame?: Game,
		quiz?: any,
		popupQuestion?: any,
		showAnswer: boolean = false,
		selectedOptionId?: string,
	) {
		switch (screenContent) {
			case ScreenContentEnum.gamePoints:
				return this._getGamePointsChart(currentEvent, currentGame);
			case ScreenContentEnum.totalPoints:
				return this._getTotalPointsChart(currentEvent);
			case ScreenContentEnum.rules:
				return this._getRulesContent(currentGame);
			case ScreenContentEnum.jeopardyGrid:
			case ScreenContentEnum.jeopardyPopup:
				// Consolidated to preserve component instance and state (usedCells)
				const isPopup = screenContent === ScreenContentEnum.jeopardyPopup;
				const pQuestion = isPopup ? popupQuestion : null;
				const sAnswer = isPopup ? showAnswer : false;

				return html`
                  <div style="position:fixed; top:0; left:0; width:100vw; height:100vh; overflow:hidden; margin:0; padding:0; background:var(--color-background);">
                    <jeopardy-grid-display style="width:100%; height:100%;" .quiz=${quiz} .popupQuestion=${pQuestion} .showAnswer=${sAnswer}></jeopardy-grid-display>
                  </div>
                `;
			case ScreenContentEnum.millionaire:
				return html`
					<div style="position:fixed; top:0; left:0; width:100vw; height:100vh; overflow:hidden; margin:0; padding:0; background:var(--color-background);">
						<millionaire-broadcast
							style="width:100%; height:100%;"
							.question=${popupQuestion}
							.showAnswer=${showAnswer}
							.selectedOptionId=${selectedOptionId}
						></millionaire-broadcast>
					</div>
				`;
			case ScreenContentEnum.default:
				return this._getDefaultContent(this.roomId);
			default:
				return this._getDefaultContent(this.roomId);
		}
	}

	private _getGamePointsChart(currentEvent: BigBashEvent, currentGame: Game): TemplateResult {
		const gamePointsBarChart = this.chartCreator.getGamePointsChart(currentEvent, currentGame);

		return html`
			<game-points-component
				.gameName=${currentGame?.name ?? "Game Points"}
				.barChart=${gamePointsBarChart}
			></game-points-component>
		`;
	}

	private _getTotalPointsChart(currentEvent: BigBashEvent): TemplateResult {
		const totalPointsBarChart = this.chartCreator.getTotalPointsChart(currentEvent);

		return html`
      <score-component .barChart=${totalPointsBarChart}></score-component>
    `;
	}

	private _getRulesContent(currentGame: Game): TemplateResult {
		if (!currentGame || currentGame.rule_video_url === "") {
			console.log('No video URL available for the current game.');
			return html`<div class="content-section">
		<h1>No video available</h1>
		</div>`;
		}
		return html`
            <video-player style="width: 100%; height: 100%;" videoLink="${currentGame.rule_video_url}"></video-player>
    `;
	}

	private _getDefaultContent(roomId: string): TemplateResult {
		return html`
    <default-display-component .roomId=${roomId}></default-display-component>
  `;
	}
}
export default DisplayContentSwitch;
